import { usePolicyCategory } from "repositories/office-policy-management-repository";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

/**
 * Provides shared data for Add/Edit Policy Folder: accountOwnerId, categoryList, refetchCategories.
 * Uses useAccountOwnerCommon for access context (no policy listing).
 */
export default function useManageOfficePolicyController(
  t,
  history,
  addOfficePolicy,
  assigneeOfficePolicyId,
  handleActionOfficePolicy = () => {},
  options = {},
) {
  const { isCategoryModalOpen = false } = options;
  const {
    effectiveOwnerId: accountOwnerId,
    isOwner: isAccountOwner,
    isStaff,
    dataAccessValues,
  } = useAccountOwnerCommon();

  const staffCanAccess = isStaff && dataAccessValues?.isAdmin;
  const canAccessThisPage = isAccountOwner || staffCanAccess;

  const { data: categoryResponse, refetch: refetchCategories } =
    usePolicyCategory(accountOwnerId, {
      enabled:
        !!accountOwnerId && canAccessThisPage && isCategoryModalOpen === true,
    });

  let categoryList = [];
  if (Array.isArray(categoryResponse?.data)) {
    categoryList = categoryResponse.data;
  } else if (Array.isArray(categoryResponse)) {
    categoryList = categoryResponse;
  }

  return {
    data: {
      accountOwnerId,
      categoryList,
      refetchCategories,
    },
  };
}
